import App from "app/App";
import { userRoutes } from "config/routes";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import * as Cookie from "js-cookie";
// import jwtDecode from "jwt-decode";
// import moment from "moment";
// interface DecodeToken {
//   exp: Number;
// }
export const PrivateRoute = ({ ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      // const currentUser = authenticationService.currentUserValue;
      const token = Cookie.get("Token");
      if (
        !token
      ) {
        return (
          <Redirect
            to={{
              pathname: `/login`,
              state: { from: props.location },
            }}
          />
        );
      }
      return (
        <React.Suspense fallback={null}>
          <App>
            <Switch>
              <Route
                exact
                path={`/`}
                render={() => {
                  return <Redirect to={`/landing-page`} />;
                }}
              />
              {userRoutes.map(({ path, component: Component }) => (
                <Route
                  key={path}
                  path={path}
                  render={(props) => {
                    return <Component />;
                  }}
                ></Route>
              ))}
            </Switch>
          </App>
        </React.Suspense>
      );
    }}
  />
);
